import { SubHeader, SubHeaderProps } from "@/components/SubHeader";
import { useSize } from "ahooks";
import { SafeArea } from "antd-mobile";
import { PropsWithChildren } from "react";
import styles from "./index.module.scss";
type SubLayoutProps = {
  title?: string;
  footer?: React.ReactNode;
  header?: SubHeaderProps;
  bg?: boolean;
  className?: string;
};
export function SubLayout(props: PropsWithChildren<SubLayoutProps>) {
  const size = useSize(document.querySelector("body"));
  return (
    <main
      className={`${styles.sub_page} ${props.bg ? styles.bg : ""} ${
        props.className || ""
      }`}
      style={{ height: size ? size.height + "px" : "auto" }}
    >
      <div className={styles.sub_main}>
        <header className={styles.sub_page_header}>
          <SubHeader
            {...(props.header || {})}
            title={props.header?.title || props.title}
          />
        </header>
        <article className={styles.sub_page_content}>{props.children}</article>
        {props.footer ? (
          <footer className={styles.sub_page_footer}>{props.footer}</footer>
        ) : null}
      </div>

      <SafeArea position="bottom" />
    </main>
  );
}

export default SubLayout;
